import { useEffect } from "react";
import { rulebaseApi2Request } from "../lib/rulebase-api2-client/client";

const INTERACTION_EVENTS = [
  "pointerdown",
  "keydown",
  "wheel",
  "touchstart",
] as const;
// Matches api2's activity write throttle.
const PING_INTERVAL_MS = 60_000;

/**
 * Beam shares the dashboard session, and API requests no longer count as
 * activity. Report real interaction (throttled) so members working only in
 * Beam are not signed out for inactivity.
 */
export function useSessionActivityReporter() {
  useEffect(() => {
    let lastPingAt = 0;
    const handleInteraction = () => {
      const now = Date.now();
      if (now - lastPingAt < PING_INTERVAL_MS) return;
      lastPingAt = now;
      rulebaseApi2Request("/session/activity", { method: "POST" }).catch(() => {
        // A signed-out or offline Beam surfaces through its own requests.
      });
    };
    for (const event of INTERACTION_EVENTS)
      window.addEventListener(event, handleInteraction, {
        capture: true,
        passive: true,
      });
    return () => {
      for (const event of INTERACTION_EVENTS)
        window.removeEventListener(event, handleInteraction, { capture: true });
    };
  }, []);
}
